import React from "react"
import TextField from "material-ui/TextField"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import moment from "moment"
import { IPunchSetDocument, IDate } from "../../models"
import { green500, red500, blue500, purple500 } from "material-ui/styles/colors"
import AppStateStore from "../../stores/AppStateStore"
import PunchStore from "../../stores/PunchStore"
import { isMobile } from "react-device-detect"
import MobileClickableTextField from "../common/MobileClickableTextField"
import SimpleTimeEditor from "../common/SimpleTimeEditor"
import * as timeHelper from "../../helpers/timeHelper"

interface IProps {
	//value and actual value is browser local time
	value: string
	actualValue?: IDate
	punchId?: string
	punchSet?: IPunchSetDocument
	systemModified?: boolean
	modified?: boolean
	timeChanged?: boolean
	readonly?: boolean
	hintText: string
	missingPunch?: boolean
	timeFraud?: boolean
	//updateDateTime is client real local time
	handleUpdatePunchTime?(punchId: string, updateDateTime: IDate, errorCb: () => void): void
	onRemovePunch?(punchId: string): void
	onAddPunch?(): void
	handleOpenPunchDetailDialog?(): void
}
interface IState {
	value: string
	showSingleControl: boolean
	showRemoveEditIcons: boolean
	infoIconHover: boolean
	clickState: boolean
}

export default class TimecardPunchControl extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			value: "",
			showSingleControl: true,
			showRemoveEditIcons: false,
			infoIconHover: false,
			clickState: false,
		}
		autobind(this)
	}

	componentDidMount() {
		this.setValueByProps(this.props)
		PunchStore.on("faled_patch_punch", () => this.setValueByProps(this.props))
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.value === nextProps.value && this.props.punchId === nextProps.punchId) return
		this.setValueByProps(nextProps)
	}

	componentWillUnmount() {
		PunchStore.removeListener("faled_patch_punch", () => this.setValueByProps(this.props))
	}

	setValueByProps(props: IProps) {
		this.setState({
			value: props.value && props.punchId ? moment(props.value).parseZone().format("hh:mma") : "",
			showSingleControl: props.value && props.punchId ? false : true
		})
	}

	render() {
		const textColor = this.props.punchSet && (this.props.punchSet.TimeOffRequestId || this.props.punchSet.HolidayName) ?
			green500 :
			this.props.systemModified ?
				blue500 :
				this.props.modified ?
					this.props.timeChanged ?
						red500 :
						purple500 :
					null
		return (
			<div
				style={{ width: 85 }}
				onMouseOver={() => this.setState({ showRemoveEditIcons: true })}
				onMouseOut={() => this.setState({ showRemoveEditIcons: false })}
			>
				{this.state.showSingleControl ?
					this.props.readonly ?
						<span /> :
						isMobile ?
							<MobileClickableTextField
								data-intercom-target={"menu-Employees-Timecards-Entry-AddPunch"}
								style={{ width: "80%", fontSize: 12 }}
								textStyle={this.props.missingPunch ? { color: "#fd6c6c" } : null}
								underlineStyle={this.props.missingPunch ? { borderColor: "#fd6c6c" } : null}
								text={this.props.hintText}
								onClick={() => this.props.onAddPunch &&
									this.props.onAddPunch()
								}
							/> :
							<TextField
								data-intercom-target={"menu-Employees-Timecards-Entry-AddPunch"}
								name="Single"
								value={this.state.value}
								hintText={this.props.hintText}
								style={{ width: "80%", fontSize: 12 }}
								ref="field"
								onClick={() => this.props.onAddPunch &&
									this.props.onAddPunch()
								}
								hintStyle={this.props.missingPunch ? { color: "#fd6c6c" } : null}
								underlineStyle={this.props.missingPunch ? { borderColor: "#fd6c6c" } : null}
							/> :
					<div style={{ display: "flex", alignItems: "center" }}>
						<i
							data-intercom-target={"menu-Employees-Timecards-Btn-OpenPunchDetail"}
							className="fa fa-info-circle"
							style={{
								marginRight: 5,
								cursor: "pointer",
								display: "inline-block",
								color: this.props.timeFraud ? red500 : this.state.infoIconHover ? "#666666" : "#aaaaaa"
							}}
							onMouseOver={() => this.setState({ infoIconHover: true })}
							onMouseOut={() => this.setState({ infoIconHover: false })}
							onClick={this.props.handleOpenPunchDetailDialog}
							title={this.props.timeFraud ?
								strings.Time_Fraud_Alert :
								this.props.actualValue && moment(this.props.actualValue).parseZone().format("hh:mm:ss a")
							}
						/>
						{this.props.readonly ?
							<span
								data-intercom-target={"menu-Employees-Timecards-Btn-OpenPunchDetail"}
								style={{ color: "#888888" }}
								onClick={() => isMobile && this.props.punchSet && this.props.handleOpenPunchDetailDialog()}
							>
								{this.state.value}
							</span> :
							[
								<SimpleTimeEditor
									key="timeeditor"
									smallText
									dataIntercomTargetStr={`menu-Employees-Timecards-Entry-Punch${this.props.hintText}`}
									simpleTime={{ Hour: moment(this.props.value).parseZone().hour(), Minute: moment(this.props.value).parseZone().minute() }}
									handleMobileClick={this.props.handleOpenPunchDetailDialog}
									textFieldStyle={{ color: textColor }}
									semicolonColor={textColor}
									checkAllowChange={() => {
										if (this.props.punchSet && this.props.punchSet.TimeOffRequestId) {
											AppStateStore.setProgressSnackbarContent(strings.Cannot_update_leave_request_punch)
											return false
										}
										return true
									}}
									handleSlowChange={async (simpleTime, revertToOldValueCb: () => void) => {
										if (!this.props.handleUpdatePunchTime) return
										const punchUTCTime = this.props.punchId === this.props.punchSet.PunchInId ?
											this.props.punchSet.PunchInTime :
											this.props.punchSet.PunchOutTime
										const punchClientLocalTime = await timeHelper.getDateTime(this.props.punchSet.HierarchyItemId, this.props.punchSet.JobId, punchUTCTime)
										this.props.handleUpdatePunchTime(
											this.props.punchId,
											punchClientLocalTime.hour(simpleTime.Hour).minute(Number(simpleTime.Minute)).second(0).format(),
											revertToOldValueCb
										)
									}}
								/>,
								!isMobile &&
								<i
									data-intercom-target={`menu-Employees-Timecards-Btn-Remove-Punch${this.props.hintText}`}
									key="remove"
									className="fa fa-remove"
									onClick={() => this.props.onRemovePunch && this.props.onRemovePunch(this.props.punchId)}
									style={{
										width: 15, marginLeft: 1, color: "#aaaaaa", cursor: "pointer",
										opacity: isMobile || this.state.showRemoveEditIcons ? 1 : 0
									}}
								/>
							]
						}
					</div>
				}
			</div>
		)
	}
}